import * as React from 'react';
import Div from "@jumbo/shared/Div";
import TopNavBar from 'app/components/TopNavBar/TopNavBar';
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Avatar, Typography } from "@mui/material";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { requestApi } from 'app/utils/RestApi';
import { COMMON, REFERRER } from 'app/utils/constants/endPoint';
import Swal from 'sweetalert2';
import editReferrerSchema from '../micrositeProfileEdit/editReferrerSchema';
import { Field, Form, Formik } from 'formik';
import { formatNpwpNumber } from 'app/utils/appHelpers';
import InputIcon from 'app/components/InputIcon';
import { Required } from 'app/utils/constants/validation';
import DropdownInput from 'app/components/DropdownInput';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InputMask from 'app/components/InputMask/InputMask';
import { getFile } from 'app/services/imageService';
import Footer from "app/components/Footer";

function MicrositeProfileEdit() {
	const navigate = useNavigate();

	const [fieldTouched, setFieldTouched] = React.useState({
		bankName: false,
		name: false,
		email: false,
		accountNumber: false,
		accountName: false,
		npwpStatus: false,
		npwpNumber: false,
	});
	const fileInputRef2 = React.useRef(null);

	const [npwpImage, setNpwpImage] = React.useState('');

	const [mstBank, setMstBank] = React.useState([])

	const [bankName, setBankName] = React.useState(null);

	const labeling = {
		id: 'value',
		name: 'label'
	}

	const [referrer, setReferrer] = React.useState({})

	const [formData, setFormData] = React.useState({
		bankName: null,
		accountNumber: '',
		accountName: '',
		npwpStatus: '',
		npwpNumber: '',
		agentCode: ''
	})

	const hasInitialized = React.useRef(false);

	React.useEffect(() => {
		if (hasInitialized.current) return;
		hasInitialized.current = true;
		initData()
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);


	const initData = async () => {
		localStorage.removeItem('edit_profile_referrer')
		const userdataLS = localStorage.getItem('userdata')
		let userdata = JSON.parse(userdataLS)
		let referrerTemp = userdata.userLoggedin

		console.log('referrerTemp : ', referrerTemp);

		let mstBankTmp = []

		await requestApi(COMMON.MASTER_BANK, {
			params: {
				name: ""
			}
		}).then(({ data }) => {
			if (data.data) {
				if (data.data.length) {
					setMstBank(data.data)
					mstBankTmp = data.data
				}
			}
		}).catch(err => console.log(err))

		if (referrerTemp) {

			if (referrerTemp.npwpImage) {
				const npwpB64 = await getFile(REFERRER.FILE,
					{
						fullPath: referrerTemp.npwpImage
					},
					false
				)

				setNpwpImage(npwpB64);
			}

			if (mstBankTmp.length > 0) {
				if (referrerTemp.bankCode) {
					setBankName(mstBankTmp.find(f => f.value == referrerTemp.bankCode))
				}
			}
			let npwpNumberData = (referrerTemp.npwpNumber) ? formatString(referrerTemp.npwpNumber) : ""
			setFormData({
				...referrerTemp,
				npwpNumber: npwpNumberData,
				agentCode: referrerTemp.agent.agentCode,
				npwpStatus: referrerTemp.npwpStatus ? '01' : '00'
			});
			setReferrer(referrerTemp)
		}


	}

	const isSubmittingRef = React.useRef(false);

	const doSubmit = async (values) => {
		if (isSubmittingRef.current) return;

		if (values.npwpStatus == '01' && !npwpImage) {
			if (!npwpImage) {
				Swal.fire({
					icon: 'warning',
					text: 'Silakan pilih foto npwp'
				});
				return false;
			}
		}

		isSubmittingRef.current = true;
		try {
			await sendData(values);
		} finally {
			setTimeout(() => {
				isSubmittingRef.current = false;
			}, 1000);
		}
	};


	const sendData = async (data) => {
		const request = {
			bankCode: bankName.value,
			bankName: bankName.label,
			accountNumber: (String(data.accountNumber)).trim(),
			accountName: (data.accountName).trim(),
			npwpStatus: data.npwpStatus == '01',
			npwpNumber: data.npwpStatus == '01' ? formatNpwpNumber(data.npwpNumber) : '',
			npwpImage: data.npwpStatus == '01' ? npwpImage : '',
		};

		request.agentCode = formData.agentCode.trim();
		if (request.agentCode.includes('%20')) {
			request.agentCode = request.agentCode.replaceAll("%20", "");
		}

		if (referrer?.id) {
			request.id = referrer?.id
		}

		localStorage.setItem("edit_profile_referrer", JSON.stringify(request))

		navigate('/micrositeOtp')
	}


	const handleImageUpload = (event, setImage) => {
		const file = event.target.files[0];
		if (file && file.size <= 1000000) {
			const reader = new FileReader();
			reader.onloadend = () => {
				setImage(reader.result);
			};
			reader.readAsDataURL(file);
		} else if (file) {
			Swal.fire({
				icon: 'error',
				text: 'File teralu besar. Maksimal Upload File 2MB.'
			});
		}
	};

	const handleImageClick2 = (event) => {
		if (fileInputRef2.current) {
			fileInputRef2.current.click();
		}
	};

	function formatString(str) {
		if (str.length !== 15) {
			return "";
		}

		const part1 = str.slice(0, 2);
		const part2 = str.slice(2, 5);
		const part3 = str.slice(5, 8);
		const part4 = str.slice(8, 9);
		const part5 = str.slice(9, 12);
		const part6 = str.slice(12, 15);

		return `${part1}.${part2}.${part3}.${part4}-${part5}.${part6}`;
	}

	const handleDropdownChange = (data) => {
		setBankName(data)
	};

	return (
		<Div className='page-wrapper profile-page'>
			<TopNavBar activeMenu={1} />
			<ContentWrapper className="wrapper-profile">
				<Div>
					<Div className='bg-profile'>
						<Div>
							<Div>
								<Div className='w-100 profile-data'>
									<Row>
										<Col lg={6} md={8}>
											<Div className='flex-justify-start' sx={{ alignItems: 'flex-start' }}>
												<Div className='back-icon-profile'>
													<KeyboardBackspaceIcon onClick={() => navigate(-1)} />
												</Div>
												<Div className='profile-detail'>
													<Avatar sx={{ width: 90, height: 90 }} />
												</Div>
												<Div className='profile-name'>
													<Typography fontSize={16} fontWeight={400} color={'white'}>{referrer?.name}</Typography>
													<Typography fontSize={16} fontWeight={400} color={'white'}>{referrer?.phoneNumber}</Typography>
													<Typography fontSize={16} fontWeight={400} color={'white'}>{referrer?.email}</Typography>
												</Div>
											</Div>
										</Col>
										<Col className='profile-right' lg={6} md={4}>
											<Row>
												<Col lg={12} md={12} xs={6}>
													<Div sx={{ mt: 4 }}>
														<Typography fontSize={14} fontWeight={400} color={'white'}>Kode Referral</Typography>
														<Typography fontSize={20} fontWeight={600} color={'white'}>{referrer?.referrerCode}</Typography>
													</Div>
												</Col>
											</Row>
										</Col>
									</Row>
								</Div>
							</Div>

						</Div>
					</Div>
					<Div className='content-padding' sx={{ background: '#ffffff', borderRadius: '0 0 15px 15px' }}>
						<Formik
							initialValues={formData}
							enableReinitialize={true}
							validationSchema={editReferrerSchema}
							onSubmit={(values) => {
								doSubmit(values)
							}}
						>
							{({ errors, values, handleSubmit, setValues }) => {

								function formikSetValue(field, value) {
									setValues({
										...values,
										[field]: value
									})
								}
								return (
									formData &&
									<Form style={{ width: '100%' }}>
										{/* 🔥 CONTENT */}
										<ContentWrapper isMobile>


											{/* 🔥 typography */}
											<Typography fontSize={16} fontWeight={600}>Silakan Lengkapi Data Diri Anda</Typography>

											{/* 🔥 input with icon left/right */}

											<Div sx={{ mt: 2 }}>
												<Field name="bankName">
													{({
														field,
														value,
														form: { handleChange },
														meta,
													}) => (
														<Div sx={{ mb: 2 }}>
															<Typography variant={"body1"} fontWeight={500} mb={1} fontSize={12}>Nama Bank {Required}</Typography>
															<DropdownInput
																required

																data={mstBank}
																value={bankName}
																onBlur={() => {
																	if (!fieldTouched.bankName) {
																		setFieldTouched((prevState) => ({ ...prevState, ['bankName']: true }))
																	}
																}}
																defaultValue={"Silakan pilih Nama Bank"}
																size={'small'}
																inputLabel={"Nama Bank"}
																placeholder={"Nama Bank"}
																name="bankName"
																noTitle={true}
																onChange={(_, data) => {
																	handleDropdownChange(data)
																	// handleChange(data[[labeling.id]])
																	formikSetValue('bankName', data[[labeling.id]])

																}}
																labeling={labeling}
															/>
															{(fieldTouched.bankName && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
														</Div>
													)}
												</Field>

												<Field name="accountNumber">
													{({
														field,
														value,
														form: { handleChange },
														meta,
													}) => (
														<Div sx={{ mb: 2 }}>
															<InputIcon
																required
																value={meta.value}
																onBlur={() => {
																	if (!fieldTouched.accountNumber) {
																		setFieldTouched((prevState) => ({ ...prevState, ['accountNumber']: true }))
																	}
																}}
																name="accountNumber"
																type='tel'
																onChange={handleChange}
																inputLabel={"Nomor Rekening"}
																placeholder={"Nomor Rekening"}

															/>
															{(fieldTouched.accountNumber && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
														</Div>
													)}
												</Field>

												<Field name="accountName">
													{({
														field,
														value,
														form: { handleChange },
														meta,
													}) => (
														<Div sx={{ mb: 2 }}>
															<InputIcon
																required
																value={meta.value}
																onBlur={() => {
																	if (!fieldTouched.accountName) {
																		setFieldTouched((prevState) => ({ ...prevState, ['accountName']: true }))
																	}
																}}
																name="accountName"
																onChange={handleChange}
																inputLabel={"Nama Pemilik Rekening (Sesuai Buku Tabungan)"}
																placeholder={"Nama Pemilik Rekening "}

															/>
															{(fieldTouched.accountName && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
														</Div>
													)}
												</Field>

												<Field name="npwpStatus">
													{({
														field,
														value,
														form: { handleChange },
														meta,
													}) => (
														<Div>
															<FormControl>
																<FormLabel id="demo-row-radio-buttons-group-label">
																	<Typography fontSize={12} color={"black"} fontWeight={500}>NPWP {Required}</Typography>
																</FormLabel>
																<RadioGroup
																	value={meta.value}
																	onBlur={() => {
																		if (meta.value === '00') {
																			setNpwpImage('')
																			setValues({
																				...values,
																				['npwpNumber']: ''
																			})
																		}
																		if (!fieldTouched.npwpStatus) {
																			setFieldTouched((prevState) => ({ ...prevState, ['npwpStatus']: true }))
																		}
																	}}
																	row
																	aria-labelledby="demo-row-radio-buttons-group-label"
																	name="npwpStatus"
																	onChange={handleChange}
																>
																	<FormControlLabel value="01" control={<Radio />} label="Ya" />
																	<FormControlLabel value="00" control={<Radio />} label="Tidak" />
																</RadioGroup>
																{(fieldTouched.npwpStatus && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
															</FormControl>
														</Div>
													)}
												</Field>

												{
													values.npwpStatus === '01' &&
													<Field name="npwpNumber">
														{({
															field,
															value,
															form: { handleChange },
															meta,
														}) => (
															<Div sx={{ mb: 2 }}>
																<InputMask
																	required={values.npwpStatus === '01'}
																	value={meta.value}
																	onBlur={() => {
																		if (!fieldTouched.npwpNumber) {
																			setFieldTouched((prevState) => ({ ...prevState, ['npwpNumber']: true }))
																		}
																	}}
																	mask="99.999.999.9-999.999"
																	name="npwpNumber"
																	onChange={handleChange}
																	inputLabel={"Nomor NPWP"}
																	placeholder={"Nomor NPWP"}
																/>
																{(fieldTouched.npwpNumber && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
															</Div>
														)}
													</Field>
												}

												{
													values.npwpStatus === '01' &&
													<>
														<Typography sx={{ mt: 2 }} fontSize={12} fontWeight={600} textAlign={"center"}>Silakan Upload Dokumen-Dokumen Di bawah ini</Typography>

														<Div className='dis-flex-center'>
															<input
																ref={fileInputRef2}
																type="file"
																style={{ display: "none" }}
																accept="image/*"
																onChange={(e) => handleImageUpload(e, setNpwpImage)}  // Assuming first image upload is for KTP
															/>
															<img
																src={npwpImage || `${process.env.REACT_APP_IMAGES_PATH}/NPWP.svg`}
																onClick={handleImageClick2}
																width={500}
																height={500}
																style={{ cursor: "pointer", objectFit: "contain", marginLeft: 10 }}
															/>
														</Div>
													</>
												}

											</Div>

										</ContentWrapper>

										{/* 🔥 FOOTER */}
										<Div className='flex-justify-center'>
											<ButtonStyled
												disabled={(values.npwpStatus === '01' ? npwpImage == '' : false) || (Object.values(errors).length > 0)}
												btnText={"Kirim"}
												preset={"primary"}
												onClick={handleSubmit}
											/>
										</Div>

									</Form>
								)
							}}

						</Formik>

					</Div>
				</Div>

			</ContentWrapper>
			<Footer />
		</Div>


	);

}

export default MicrositeProfileEdit;